import React from 'react';
import styles from './ShoutItem.scss';

const ShoutItem = ({ shout }) => (
	<div className={styles.root}>
		<p>
			<span className={styles.name}>
				{shout.user.username || shout.user.firstName || shout.user.name}
				{':'}
			</span>

			<span className={styles.content}>{shout.content.text}</span>
		</p>
	</div>
);
export default ShoutItem;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/shoutbox/childcomponents/ShoutItem.js